import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminEditUserSettings from "../../Components/Admin/AdminEditUserSettings";
import SideBar from "../../Components/Admin/SideBar";

const AdminEditUserSettingsPage = () => {
  return (

    <AdminEditUserSettings />

  );
};

export default AdminEditUserSettingsPage;
